/**
 * NOTE: Could be merged with ChartApp in the future.
 * Kept separate because JMI/JMO data format differs from other chart types.
 */
import React, { useState, useRef, createContext } from "react";
import { DataDownloader } from "./components/DataDownloader";
import ChartCommon from "./components/charts/ChartCommon";
import Header from "./components/Header";
import MultiSelect from "./components/MultiSelect";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import infoIcon from "../images/icons/info.svg";
export const PrintContext = createContext(null);
export function JmiJmoApp({ pageType, mainPageData, fileDownloadLink, checkboxesRaw, }) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const printContentRef = useRef(null);
    const descriptionsMap = new Map();
    (_c = (_b = (_a = checkboxesRaw === null || checkboxesRaw === void 0 ? void 0 : checkboxesRaw.groups) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.items) === null || _c === void 0 ? void 0 : _c.forEach((item) => {
        const keyWithoutUnits = item.name.replace(/\s*\[.*?\]\s*$/g, '').trim();
        descriptionsMap.set(keyWithoutUnits, item.description);
    });
    const [selectedTechnology, setSelectedTechnology] = useState({
        chosenCategoryId: (_d = mainPageData[0]) === null || _d === void 0 ? void 0 : _d.categoryId,
        chosenCategoryLabel: (_e = mainPageData[0]) === null || _e === void 0 ? void 0 : _e.category,
    });
    const [selectedMetric, setSelectedMetric] = useState({
        chosenValueId: "",
        chosenValueLabel: "",
    });
    const [multiSelects, setMultiSelects] = useState({});
    const [optionsSelected, setOptionsSelected] = useState();
    const [resetMulti, setResetMulti] = useState(false);
    React.useEffect(() => {
        const allSelected = [];
        Object.values(multiSelects).forEach((items) => {
            if (Array.isArray(items)) {
                items.forEach((item) => {
                    allSelected.push({ label: item.label });
                });
            }
        });
        setOptionsSelected(allSelected.length > 0 ? allSelected : undefined);
    }, [multiSelects]);
    const originalCategory = mainPageData.find((cat) => cat.categoryId === selectedTechnology.chosenCategoryId);
    const mockDataCategory = originalCategory ? Object.assign(Object.assign({}, originalCategory), { values: (_f = originalCategory.values) === null || _f === void 0 ? void 0 : _f.map((val) => (Object.assign(Object.assign({}, val), { description: descriptionsMap.get(val.value) || val.description || "" }))) }) : null;
    const metrics = ((_g = mockDataCategory === null || mockDataCategory === void 0 ? void 0 : mockDataCategory.values) === null || _g === void 0 ? void 0 : _g.map((val) => ({
        id: val.id,
        value: val.value,
        label: val.value,
        description: val.description,
    }))) || [];
    React.useEffect(() => {
        if (metrics.length > 0 && !selectedMetric.chosenValueId) {
            setSelectedMetric({
                chosenValueId: metrics[0].id,
                chosenValueLabel: metrics[0].label,
            });
        }
    }, [metrics.length]);
    const sectorsFilter = ((_h = mockDataCategory === null || mockDataCategory === void 0 ? void 0 : mockDataCategory.filters) === null || _h === void 0 ? void 0 : _h[0])
        ? Object.assign(Object.assign({}, mockDataCategory.filters[0]), { values: mockDataCategory.filters[0].values.filter((v) => v.value && v.value !== 'nan' && v.value !== 'NaN' && v.key && v.key !== 'nan' && v.key !== 'NaN') }) : null;
    const handleTechnologyChange = (categoryId, category) => {
        setSelectedTechnology({
            chosenCategoryId: categoryId,
            chosenCategoryLabel: category
        });
    };
    const pageTitle = pageType === "economic_jmi_data" ? "Dane JMI" : "Dane JMO";
    const TooltipJMI = (React.createElement(Tooltip, null, "Jednostkowe mno\u017Cniki inwestycyjne ilustruj\u0105 wielko\u015B\u0107 i sektorowy rozk\u0142ad wzrostu produkcji krajowej, warto\u015Bci dodanej, a tak\u017Ce nowych miejsc pracy wywo\u0142ane przez instalacj\u0119 1 MW mocy w wybranej technologii."));
    const TooltipJMO = (React.createElement(Tooltip, null, "Jednostkowe mno\u017Cniki operacyjne ilustruj\u0105 wielko\u015B\u0107 i sektorowy rozk\u0142ad wzrostu produkcji krajowej, warto\u015Bci dodanej, a tak\u017Ce nowych miejsc pracy wywo\u0142ane przez utrzymywanie 1 MW mocy w wybranej technologii przez okres jednego roku."));
    return (React.createElement("div", { className: "container my-5" },
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-3" },
                React.createElement("div", { className: "radioSidebar" },
                    React.createElement("div", { className: "card mb-4" },
                        React.createElement("div", { className: "card-body" },
                            React.createElement("h1", { className: "fs-4 fw-bold mb-0 d-flex justify-content-between align-items-center" },
                                pageTitle,
                                React.createElement(OverlayTrigger, { placement: "right", overlay: pageType === "economic_jmi_data" ? TooltipJMI : TooltipJMO },
                                    React.createElement("img", { src: infoIcon, alt: "Ikona informacji", className: "ms-1" }))))),
                    React.createElement("div", { className: "card" },
                        React.createElement("div", { className: "card-header" },
                            React.createElement("h5", { className: "mb-0" }, "Technologie")),
                        React.createElement("div", { className: "card-body" }, mainPageData.map((tech) => (React.createElement("div", { key: tech.categoryId, className: "form-check mb-2 clickable" },
                            React.createElement("input", { className: "form-check-input clickable", type: "radio", name: "technology", id: tech.categoryId, checked: selectedTechnology.chosenCategoryId === tech.categoryId, onChange: () => handleTechnologyChange(tech.categoryId, tech.category) }),
                            React.createElement("label", { className: "form-check-label clickable", htmlFor: tech.categoryId }, tech.category)))))))),
            React.createElement("div", { className: "col-9" },
                React.createElement("div", { className: "row" },
                    React.createElement("div", null,
                        React.createElement(Header, { chosenCategory: selectedTechnology, chosenValue: selectedMetric, mockDataCategory: mockDataCategory }))),
                React.createElement("div", { className: "row mb-4 mt-2" },
                    React.createElement("div", { className: "col-6" },
                        React.createElement(MultiSelect, { id: "metric-select", options: {
                                filter: "Estymowane efekty gospodarcze i środowiskowe",
                                filterId: "metric-select",
                                values: metrics.map((m) => ({
                                    key: m.id,
                                    value: m.label,
                                }))
                            }, setOptionsSelected: () => { }, multiSelects: { "metric-select": selectedMetric.chosenValueId ? [{ value: selectedMetric.chosenValueId, label: selectedMetric.chosenValueLabel }] : [] }, setMultiSelects: (newValue) => {
                                const selectedValues = newValue["metric-select"];
                                if (selectedValues && selectedValues.length > 0) {
                                    const metric = metrics.find((m) => m.id === selectedValues[0].value);
                                    if (metric) {
                                        setSelectedMetric({
                                            chosenValueId: metric.id,
                                            chosenValueLabel: metric.label,
                                        });
                                    }
                                }
                            }, resetMulti: false, setResetMulti: () => { }, isMulti: false, setIsMultiArray: () => { }, area: { value: "default", label: "Default" }, setArea: () => { } })),
                    sectorsFilter && (React.createElement("div", { className: "col-6" },
                        React.createElement(MultiSelect, { id: sectorsFilter.filterId, options: sectorsFilter, setOptionsSelected: () => { }, multiSelects: multiSelects, setMultiSelects: (newValue) => {
                                setMultiSelects(Object.assign({}, newValue));
                            }, resetMulti: resetMulti, setResetMulti: setResetMulti, isMulti: true, setIsMultiArray: () => { }, area: { value: "default", label: "Default" }, setArea: () => { } })))),
                React.createElement("div", { className: "row mt-3" },
                    React.createElement("div", null,
                        React.createElement("div", { className: "print-area" },
                            React.createElement(PrintContext.Provider, { value: printContentRef }, selectedMetric.chosenValueId && mockDataCategory && (React.createElement(ChartCommon, { pageType: pageType, multiSelects: multiSelects, chosenCategory: selectedTechnology, chosenValue: selectedMetric, mockDataCategory: mockDataCategory, optionsSelected: optionsSelected, isStacked: true, selectedChart: "bar-chart", area: { value: "default", label: "Default" } })))),
                        React.createElement(DataDownloader, { downloadLink: fileDownloadLink, printContentRef: printContentRef })))))));
}
